import React, { useState } from "react";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import '../Style/Dashboard.css';
import "../Style/DebitNote.css"
import axios from "axios";
import { useNavigate } from "react-router-dom";
import '../Style/CreateDebitNote.css';
import {BASE_URL} from "../Apis/apiConfig";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const CreateDebitNote = () => {
  const navigate = useNavigate();
   const [formData, setFormData] = useState({
    flatNo: "",
    noteNo: "",
    amount: "",
  });
  const [loading, setLoading] = useState(false);
const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!formData.flatNo) newErrors.flatNo = "noteNo name is required";
    if (!formData.noteNo) newErrors.noteNo = "Designation is required";
    if (!formData.amount) newErrors.email = "amount is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    const formParams = new URLSearchParams();
    formParams.append("flatNo", formData.flatNo);
    formParams.append("noteNo", formData.noteNo);
    formParams.append("amount", formData.amount);
   

    try {
      const token = localStorage.getItem("token");

      const response = await axios.post(
        `${BASE_URL}/api/debit/add-debit-note`,
        formParams,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );
      window.location.reload();
      alert("Employee added successfully");
       toast.success("Employee added successfully", {
          position: "bottom-right",
          autoClose: 3000,
        });

      window.location.reload();
      console.log(response.data);
    } catch (error) {
      console.error("Error adding employee:", error);
      alert("Failed to add employee");
    
  };
}


  return (
    <>
      <div><Header /></div>
      <div className="d-flex">
        <Sidebar />
        <div className="flex-grow-1 right-section">
          <SubHeader />
          <div className="container-fluid p-1 m-0">
            <div className="row">
              <div className="col-md-3">
                <div className="notice-list-container p-3 mb-4">
                  <div className="row custom-row">
                    <div style={containerStyle} >
                      <ul style={{ listStyle: 'none', padding: 0, margin: 0, width: '100%' }}>
                        <li style={buttonStyle}><div>All Memember Credit note</div></li>
                        <li style={buttonStyle}><div>First Floor <br/>FLAT No 201-201</div></li>
                        <li style={buttonStyle}><div>First Floor <br/>FLAT No 201-201</div></li>
                        <li style={buttonStyle}><div>First Floor <br/>FLAT No 201-201</div></li>
                        <li style={buttonStyle}><div>First Floor <br/>FLAT No 201-201</div></li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-md-9 m-0">
                <div className="row g-2">
                 <div className="form-container">
                  <hr className="header-line" />
                   
                    <form onSubmit={handleSubmit}>
                      <div className="form-group full-width">
                        <label>
                          Select Flat no<span style={{ color: "red" }}>*</span>
                        </label>
                        <select name="flatNo" value={formData.flatNo} onChange={handleChange} required>
                          <option value="">-- Select --</option>
                          <option value="101">101</option>
                          <option value="102">102</option>
                          <option value="103">103</option>
                        </select>
                      </div>

                      <div className="form-row">
                        <div className="form-group">
                          <label>
                            Note No<span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="text"
                            name="noteNo"
                            value={formData.noteNo}
                            onChange={handleChange}
                            required
                          />
                        </div>

                        <div className="form-group">
                          <label>
                            Enter Amount<span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            type="number"
                            name="amount"
                            value={formData.amount}
                            onChange={handleChange}
                            required
                          />
                        </div>
                      </div>

                      <button type="submit" className="submit-btn" disabled={loading}>
                        {loading ? "Submitting..." : "SUBMIT"}
                      </button>
                    </form>
                  </div>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
    </>
  );
};


const buttonStyle = {
  backgroundColor: "#007bb5",
  color: "white",
  border: "none",
  padding: "10px",
  margin: "6px 0",
  width: "130px",
  borderRadius: "8px",
  fontSize: "13px",
  fontWeight: "500",
  cursor: "pointer",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  textAlign: "center",
};

const containerStyle = {
  background: '#bfebfe',
  padding: "10px",
  borderRadius: "12px",
  width: "200px",
  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
};

export default CreateDebitNote;
